import { LoadState } from "../../../constants/enums";

export interface IAccountingImportBulkPaymentBillState {
  billPayment: {
    list: IImportBulkPaymentBill[];
    listLoading: LoadState;
    listError: string | null;
    billList: IImportBillPaymentList[];
    billListLoading: LoadState;
    billListError: string | null;
  };
  invoicePayment: {
    list: IImportBulkPaymentBill[];
    listLoading: LoadState;
    listError: string | null;
  };
}

export interface IImportBillPaymentList {
  create_payment_code: string | null;
  create_payment_id: string | null;
  customer_id: string | null;
  customer_policy_id: string | null;
  payment_date: string | null;
  name: string | null;
  payment_id: string | null;
  invoice_payment_code: string | null;
  date: string | null;
  payment_paid: string | null;
  is_partial_payment: string | null;
  payment_number: string | null;
  bill_number: string | null;
  bill_amount: string | null;
  vendor: string | null;
  bill_payment_details: string | null;
  payment_made: string | null;
  bank_charges: string | null;
  payment_method: string | null;
  paid_through_account: string | null;
  paid_to: string | null;
  vendor_type: string | null;
  paid_to_name: string | null;
  bill_payment_type: string | null;
  gl_account: string | null;
  invoice_payment_gl_account_name: string | null;
  reference_id: string | null;
  total_amount: string | null;
  amount_due: string | null;
  amount_paid: string | null;
  amount_used_for_payments: string | null;
  amount_refunded: string | null;
  amount_in_excess: string | null;
  reconciled: string | null;
  reconciled_date: string | null;
  notes: string | null;
  status: string;
}

export interface IImportBulkPaymentBill {
  temp_invoice_payment_id: number;
  invoice_payment_code: string | null;
  file_path: string | null;
  start_row: number | null;
  end_row: number | null;
  file_type: string;
  template_mapping_data: {
    Date: string | null;
    Debit: string | null;
    Credit: string | null;
    Posted: string | null;
    Description: string | null;
  };
  comment: string | null;
  status: string;
}

export const initialAccountingImportBulkPaymentBillState: IAccountingImportBulkPaymentBillState =
  {
    billPayment: {
      list: [],
      listLoading: LoadState.NotLoaded,
      listError: null,
      billList: [],
      billListLoading: LoadState.NotLoaded,
      billListError: null,
    },
    invoicePayment: {
      list: [],
      listLoading: LoadState.NotLoaded,
      listError: null,
    },
  };
